/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Pill_HrInputs */

const en_ui_color_by_pill_hr = /** @type {(inputs: Ui_Color_By_Pill_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HR zones`)
};

const de_ui_color_by_pill_hr = /** @type {(inputs: Ui_Color_By_Pill_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HF-Zonen`)
};

/**
* | output |
* | --- |
* | "HR zones" |
*
* @param {Ui_Color_By_Pill_HrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_pill_hr = /** @type {((inputs?: Ui_Color_By_Pill_HrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Pill_HrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_pill_hr(inputs)
	return de_ui_color_by_pill_hr(inputs)
});